/*
Copyright © 2021 EPAM Systems, Inc. All Rights Reserved.
All information contained herein is, and remains the property of EPAM Systems, Inc.
and/or its suppliers and is protected by international intellectual property law.
Dissemination of this information or reproduction of this material is strictly
forbidden, unless prior written permission is obtained from EPAM Systems, Inc
*/
import React, { useLayoutEffect } from 'react';

import './warning.scss';
import PropTypes from 'prop-types';

const warning = require('b_')
    .with('warning');

export const Warning = ({
    text,
    type,
    show,
}) => {
    const warningRef = React.useRef(null);
    useLayoutEffect(() => {
        if (!show || !text) {
            return;
        }
        // eslint-disable-next-line no-undef
        // const element = document.querySelector('.warning');
        // eslint-disable-next-line no-unused-expressions
        const element = warningRef.current;
        element &&
        element.scrollIntoView({
            block: 'center',
            behavior: 'smooth',
        });
    }, [show]);

    return !show ? null : (
        <div ref={warningRef} className={warning({ type })}>
            <p className={warning('text')}>{text}</p>
        </div>
    );
};
Warning.propTypes = {
    text: PropTypes.string,
    type: PropTypes.string,
    show: PropTypes.bool,
};

Warning.defaultProps = {
    text: 'Ошибка',
    type: 'danger',
    show: false,
};
